export default "__VITE_ASSET__BG8j8nJu__"